import { Suspense } from 'react';
import { Navigate, Route, Routes } from 'react-router';
import { useTexts } from '@/feature/lang';
import { usePermissions } from '@/feature/permissions/PermissionsProvider';
import { DocumentTitle } from '@/view/app/routing/DocumentTitle';
import { NotFound } from '../app/routing/NotFound';
import {
  companiesPath,
  equipmentPath,
  samAccountPath,
  sitesPath,
  usersPath,
} from '../pathDefinitions';
import CompanyRoutes from './company/routes';
import EquipmentRoutes from './equipment/routes';
import SamAccountRoutes from './samaccount/routes';
import SiteRoutes from './site/routes';
import UserRoutes from './user/routes';

export default function AdminRoutes() {
  const permissions = usePermissions();
  const defaultRoute = permissions.some((p) => p.startsWith('entity:'))
    ? equipmentPath
    : samAccountPath;
  const { admin, app } = useTexts();

  return (
    <Suspense fallback={<></>}>
      <Routes>
        <Route path="/" element={<Navigate to={defaultRoute} replace />} />
        <Route
          path={`${companiesPath}/*`}
          element={
            <>
              <DocumentTitle title={admin.company.list.header} />
              <CompanyRoutes />
            </>
          }
        />
        <Route
          path={`${sitesPath}/*`}
          element={
            <>
              <DocumentTitle title={admin.site.header} />
              <SiteRoutes />
            </>
          }
        />
        <Route
          path={`${equipmentPath}/*`}
          element={
            <>
              <DocumentTitle title={admin.equipment.header} />
              <EquipmentRoutes />
            </>
          }
        />
        <Route
          path={`${usersPath}/*`}
          element={
            <>
              <DocumentTitle title={admin.user.header} />
              <UserRoutes />
            </>
          }
        />
        <Route
          path={`${samAccountPath}/*`}
          element={
            <>
              <DocumentTitle title={admin.sidebar.samAccount} />
              <SamAccountRoutes />
            </>
          }
        />
        <Route
          path="*"
          element={
            <>
              <DocumentTitle title={app.routing.notFound.title} />
              <NotFound />
            </>
          }
        />
      </Routes>
    </Suspense>
  );
}
